// Shared service catalogue used by the home page cards, the footer and the
// "related services" strip on each service page.
export const SERVICES = [
  {
    title: 'Security Officers',
    description:
      'Uniformed, licensed officers posted on site — access control, lobby coverage, foot patrol and incident response, staffed to your hours.',
    path: '/services/business',
    image: '/secure2.jpeg'
  },
  {
    title: 'Mobile Patrol',
    description:
      'Marked vehicle patrols with randomized timing, documented checkpoints and alarm response across multiple properties.',
    path: '/services/mobile-patrol',
    image: '/secure4.jpeg'
  },
  {
    title: 'Firewatch',
    description:
      'Continuous fire-safety coverage while alarms or sprinklers are offline, during hot work, and throughout construction phases.',
    path: '/services/firewatch',
    image: '/secure3.jpeg'
  },
  {
    title: 'Residential & HOA',
    description:
      'Standing posts and nightly patrol for apartment communities, HOAs and gated neighborhoods, with reporting owners can share.',
    path: '/services/neighborhood',
    image: '/secure12.jpeg'
  },
  {
    title: 'Event Security',
    description:
      'Crowd management, entry screening, credentialing and VIP coverage for stadiums, festivals and private functions.',
    path: '/services/event',
    image: '/secure15.jpeg'
  },
  {
    title: 'Reporting & Oversight',
    description:
      'Every post, patrol and incident logged in one place — so you can confirm coverage instead of taking our word for it.',
    path: '/services/additional',
    image: '/secure9.png',
    imagePosition: 'object-top'
  }
];

export default SERVICES;
